import { CharacterData } from "stores/modules/entities.room.characters/operations";

type IndexedProps = {
  key: string;
  copyData: CharacterData | null;
};
const DB_NAME = "character-entries";
const VERSION = 2;
const STORE_NAME = "character";

const openIndexedDB = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, VERSION);
    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        const store = db.createObjectStore(STORE_NAME, { keyPath: "key" });
        store.createIndex("copyData", "copyData", { unique: false });
      }
    };
    request.onsuccess = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      resolve(db);
    };
    request.onerror = reject;
  });
};

const getIndexedDBStore = async (): Promise<IDBObjectStore> => {
  const db = await openIndexedDB();
  const transaction = db.transaction([STORE_NAME], "readwrite");
  const objectStore = transaction.objectStore(STORE_NAME);
  return objectStore;
};

export const writeCharacterIDB = async (value: IndexedProps) => {
  const objectStore = await getIndexedDBStore();
  objectStore.put(value);
};

export const deleteAllCharacterIDB = async () => {
  const objectStore = await getIndexedDBStore();
  objectStore.clear();
};

export const getCharacterByKeyIDB = async (
  key: string
): Promise<IndexedProps> => {
  const objectStore = await getIndexedDBStore();
  const request = objectStore.get(key);
  return new Promise((resolve, reject) => {
    request.onsuccess = () => {
      const result = request.result as IndexedProps;
      resolve(result);
    };
    request.onerror = reject;
  });
};
